import React, { useState, useRef, useEffect } from "react";

const RotatableImage = ({ src, alt, className = "", style = {} }) => {
  const [rotation, setRotation] = useState(0);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [containerSize, setContainerSize] = useState({ width: 'auto', height: 'auto' });
  const imgRef = useRef(null);

  useEffect(() => {
    if (imgRef.current && imgRef.current.complete) {
      updateDimensions();
    }
  }, [src]);

  useEffect(() => {
    if (dimensions.width && dimensions.height) {
      const isRotatedSideways = rotation === 90 || rotation === 270;
      if (isRotatedSideways) {
        setContainerSize({
          width: dimensions.height,
          height: dimensions.width
        });
      } else {
        setContainerSize({
          width: dimensions.width,
          height: dimensions.height
        });
      }
    }
  }, [rotation, dimensions]);

  const updateDimensions = () => {
    if (imgRef.current) {
      const { naturalWidth, naturalHeight } = imgRef.current;
      const aspectRatio = naturalWidth / naturalHeight;
      
      let scaledWidth, scaledHeight;
      if (naturalWidth > naturalHeight) {
        scaledWidth = Math.min(naturalWidth, 800);
        scaledHeight = scaledWidth / aspectRatio;
      } else {
        scaledHeight = Math.min(naturalHeight, 600);
        scaledWidth = scaledHeight * aspectRatio;
      }
      
      setDimensions({ width: scaledWidth, height: scaledHeight });
    }
  };

  const rotateClockwise = () => {
    setRotation((prev) => (prev + 90) % 360);
  };

  const rotateCounterClockwise = () => {
    setRotation((prev) => (prev - 90 + 360) % 360);
  };

  const isRotatedSideways = rotation === 90 || rotation === 270;

  return (
    <div 
      className="relative inline-flex items-center justify-center"
      style={{
        width: containerSize.width,
        height: containerSize.height,
        maxWidth: '100%',
        maxHeight: '100%',
        transition: 'width 0.3s ease, height 0.3s ease',
      }}
    >
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        className={className}
        onLoad={updateDimensions}
        style={{
          ...style,
          maxWidth: isRotatedSideways ? dimensions.height : dimensions.width,
          maxHeight: isRotatedSideways ? dimensions.width : dimensions.height,
          transform: `rotate(${rotation}deg)`,
          transition: "transform 0.3s ease-in-out",
          objectFit: 'contain',
        }}
      />
      <div className="absolute bottom-2 right-2 flex gap-1 z-10">
        <button
          onClick={rotateCounterClockwise}
          className="bg-gray-800 hover:bg-gray-700 text-white rounded-full p-1.5 shadow-lg transition-all duration-200 focus:outline-none"
          title="Rotate Left"
          aria-label="Rotate Left"
        >
          <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
          </svg>
        </button>
        <button
          onClick={rotateClockwise}
          className="bg-gray-800 hover:bg-gray-700 text-white rounded-full p-1.5 shadow-lg transition-all duration-200 focus:outline-none"
          title="Rotate Right"
          aria-label="Rotate Right"
        >
          <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 10h-10a8 8 0 00-8 8v2M21 10l-6 6m6-6l-6-6" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default RotatableImage;
